const UnAuthorizedError = () => {
  // Prevent redirect loop if already on sign-in page
  if (window.location.pathname === '/sign-in' || window.location.pathname === '/sign-up') {
    return;
  }
  const inviteId = localStorage.getItem('inviteId')

  localStorage.clear()

  if (inviteId !== null) {
    localStorage.setItem('inviteId', inviteId)
  }
  window.location.href = '/sign-in';
};

export default UnAuthorizedError;
